import { css } from 'linaria';
import { styled } from 'linaria/react';

export const MoreInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const MoreInfoCardImage = styled.img`
  width: 100%;
  height: 240px;
  border-radius: var(--rounding-l);
  object-fit: cover;

  @media (--only-mobile) {
    height: 160px;
  }
`;

export const moreInfoCardNameWrapper = css`
  display: flex;
  padding: 16px 0;
  column-gap: 8px;
`;

export const moreInfoCardText = css`
  @media (width >= 375px) {
    white-space: nowrap;
  }
`;

export const moreInfoCardNameIconWrapper = css`
  width: 100%;
`;

export const moreInfoCardNameIcon = css`
  top: 4px;
`;
